import { render, staticRenderFns } from "./ERtable.vue?vue&type=template&id=51c6d5a7&scoped=true"
import script from "./ERtable.vue?vue&type=script&lang=js"
export * from "./ERtable.vue?vue&type=script&lang=js"
import style0 from "./ERtable.vue?vue&type=style&index=0&id=51c6d5a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c6d5a7",
  null
  
)

export default component.exports